var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 129.01,
    height: 68.009,
    viewBox: "0 0 129.01 68.009",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.005 0.005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.738,0A6.739,6.739,0,1,1,0,6.739,6.739,6.739,0,0,1,6.738,0Z",
    transform: "translate(22.075 16.877)",
    fill: "none",
    stroke: "#0d2a63",
    strokeLinecap: "round",
    strokeWidth: 3.729
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.529,25.184V1.864H1.864v64.28h5.47a5.775,5.775,0,0,0,4.672-2.38L22.654,49.108a4.491,4.491,0,0,1,6.875-.47l3.728,3.885a4.492,4.492,0,0,0,6.885-.484l10.8-14.992a4.491,4.491,0,0,1,7.187-.134l15.92,20.434",
    transform: "translate(-0.005 -0.005)",
    fill: "none",
    stroke: "#0d2a63",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.729
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.131,37.145c-4.827-.374-8.972,4.2-10.121,10.462a20.84,20.84,0,0,1-5.278,10.288s13.15,1.233,19.191-4.807A12.556,12.556,0,0,0,97.947,45c.184-4.085-2.571-7.449-7.817-7.855",
    transform: "translate(-0.195 -0.092)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.131,37.145c-4.827-.374-8.972,4.2-10.121,10.462a20.84,20.84,0,0,1-5.278,10.288s13.15,1.233,19.191-4.807A12.556,12.556,0,0,0,97.947,45C98.131,40.915,95.376,37.551,90.131,37.145Z",
    transform: "translate(-0.195 -0.092)",
    fill: "none",
    stroke: "#0d2a63",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.418
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.539,37.055,121.69,2.193l5.839,4.855L97.979,44.823a9.5,9.5,0,0,0-8.44-7.768",
    transform: "translate(-0.233 -0.005)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.539,37.055,121.69,2.193l5.839,4.855L97.979,44.823A9.5,9.5,0,0,0,89.539,37.055Z",
    transform: "translate(-0.233 -0.005)",
    fill: "none",
    stroke: "#0d2a63",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.418
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.142,54.3a29.251,29.251,0,0,1-10.928,2.021A22.815,22.815,0,0,0,81,50.651c1.575,2.752,7.271,3.043,8.139,3.645",
    transform: "translate(-0.204 -0.125)",
    fill: "#759ce2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H129V68H0Z",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditImg);
export default __webpack_public_path__ + "static/media/edit_img.2809163cb2b044be34941114ba5d6dbb.svg";
export { ForwardRef as ReactComponent };